import {lazy, FC, Suspense} from 'react';
import {Route, Routes, Navigate} from 'react-router-dom';
import {MasterLayout} from '../../_metronic/layout/MasterLayout';
import TopBarProgress from 'react-topbar-progress-indicator';
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper';

import MyAccountPage from '../pages/myaccount/MyAccountPage';
import HardwareDebugPage from '../pages/debug/HardwareDebugPage';

import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils';
import {useAuth} from 'src/app/modules/auth';
import {CheckRole} from 'src/utils/utils';
const PrivateRoutes = () => {
  const HeThongPage = lazy(() => import('../pages/HeThongPage'));
  const QuanLyThietBi = lazy(() => import('../pages/QuanLyThietBi'));
  const ThongKeBaoCao = lazy(() => import('../pages/ThongKeBaoCao'));

  const {currentUser} = useAuth();
  const currentPermissions = currentUser?.permissions;

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />

        <Route path='myaccount' element={<MyAccountPage />} />

        {CheckRole(currentPermissions, [
          'Permissions.HeThong.Manage',
          'Permissions.DonVi.Manage',
          'Permissions.AuditTrails.Search',
          'Permissions.LoginLogs.Search',
        ]) && (
          <Route
            path='he-thong/*'
            element={
              <SuspensedView>
                <HeThongPage />
              </SuspensedView>
            }
          />
        )}
        <Route
          path='quan-ly-thiet-bi/*'
          element={
            <SuspensedView>
              <QuanLyThietBi />
            </SuspensedView>
          }
        />

        <Route
          path='bao-cao/*'
          element={
            <SuspensedView>
              <ThongKeBaoCao />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  );
};

const SuspensedView = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary');
  TopBarProgress.config({
    barColors: {
      0: baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export {PrivateRoutes};
